export function toError(response) {
  if (response.code === 500) {
    response.code = 403;
    response.data = {
      message: 'Unauthorized',
      result: 'error'
    };
  }
  return Promise.reject(response);
}